import { render } from "./performance.vue?vue&type=template&id=2de03b24&scoped=true&ts=true"
import script from "./performance.vue?vue&type=script&lang=ts&config=true"
export * from "./performance.vue?vue&type=script&lang=ts&config=true"

import "./performance.vue?vue&type=style&index=0&id=2de03b24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de03b24"]])

export default __exports__